import {pickMonth} from '.';

export function toMonthYear(date: Date) {
  return `${pickMonth(date)} ${date.getFullYear()}`;
}
